var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row overflow-auto p-4 h-full bg-slate-25 dark:bg-slate-800"},[_c('woot-wizard',{staticClass:"hide-for-small-only w-[25%]",attrs:{"global-config":_vm.globalConfig,"items":_vm.items}}),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }